module.exports = __webpack_public_path__ + "img/charger-speeds-desktop.9b5f1eda.webp";